/* eslint-disable */
// we're using a mix link/button disabling because of these rules
// jsx-a11y/click-events-have-key-events
// jsx-a11y/anchor-is-valid
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Button from '../Button';
import TranslationProvider from '../../providers/TranslationProvider';
import { LoginForm } from '../Form';
import containerQueryProps from '../../props/containerQueryProps';

import './Auth.scss';
import { AuthAnalyticsEvents, SignInMethods } from '../../containers/AuthContainer/authSteps';
import {
  AUTH_ACTIONS,
  AUTH_FLOWS,
  AUTH_METHODS,
  AUTH_STEPS,
  buildAuthDdActionName,
  trackAuthDdAction,
} from '../../utils/authDatadog';

const LOGIN_FORM_DD_ACTION_NAME = buildAuthDdActionName({
  flow: AUTH_FLOWS.SIGN_IN,
  method: AUTH_METHODS.EMAIL_PASS,
  step: AUTH_STEPS.CAPTURE_PASSWORD,
  action: AUTH_ACTIONS.CONTINUE,
});

const FORGOT_PASSWORD_DD_ACTION_NAME = buildAuthDdActionName({
  flow: AUTH_FLOWS.RESET_PASSWORD,
  method: AUTH_METHODS.EMAIL_PASS,
  step: AUTH_STEPS.CAPTURE_PASSWORD,
  action: AUTH_ACTIONS.OPEN_RESET_PASSWORD,
});

const SIGN_UP_DD_ACTION_NAME = buildAuthDdActionName({
  flow: AUTH_FLOWS.SIGN_UP,
  method: AUTH_METHODS.PHONE_CODE,
  step: AUTH_STEPS.CAPTURE_PASSWORD,
  action: AUTH_ACTIONS.OPEN_SIGN_UP,
});

const LoginView = ({
  containerQuery,
  email,
  event,
  onForgotPasswordClick,
  onSignupClick,
  onSubmit,
  venue,
}) => {
  const { sm } = containerQuery;

  useEffect(() => {

    /**
     * https://resy.atlassian.net/browse/CTF-328 - ADA issue
     */
    const closeBtn = document.querySelector('.ModalNav > .Button--close');
    closeBtn && closeBtn.focus();

    event(AuthAnalyticsEvents.START_SIGN_IN, {
      method: SignInMethods.EMAIL_PASSWORD,
    });
  }, [event]);

  const handleForgotPasswordClick = () => {
    trackAuthDdAction(FORGOT_PASSWORD_DD_ACTION_NAME, { source: 'auth' });
    event(AuthAnalyticsEvents.START_RESET_PASSWORD);
    onForgotPasswordClick();
  }

  const handleSignUpClick = () => {
    trackAuthDdAction(SIGN_UP_DD_ACTION_NAME, { source: 'auth' });
    onSignupClick();
  };

  return (
    <div className={cx('AuthView', {
      'AuthView--sm': sm,
    })}
    >
      <TranslationProvider
        translationKey={venue ? 'onboarding.title' : 'onboarding.title_secondary'}
        translationValues={{
          venueName: venue,
        }}
      >
        <div className="AuthView__Text--light" style={{ marginBottom: '10px' }}>
          Resy’s hospitality platform securely manages your account information and reservations.
        </div>
      </TranslationProvider>
      <TranslationProvider
        translationKey="onboarding.please_log_in"
      >
        <h2 className="AuthView__Headline" style={{ marginBottom: '30px' }}>
          Please log in:
        </h2>
      </TranslationProvider>
      <LoginForm
        onSubmit={onSubmit}
        email={email}
        datadogActionName={LOGIN_FORM_DD_ACTION_NAME}
      />
      <div className={cx('AuthView__Footnote', {
        'AuthView__Footnote--sm': sm,
      })}
      >
        <TranslationProvider
            translationKey="forgot_password"
          >
          <Button
            onClick={handleForgotPasswordClick}
            style={{ textTransform: 'capitalize' }}
            role="link"
            variant="link"
            id="forgot-password-button"
            data-dd-action-name={FORGOT_PASSWORD_DD_ACTION_NAME}
          >
              Forgot Password?
          </Button>
        </TranslationProvider>
      </div>
      <div className="AuthView__Divider" />
      <div className={cx('AuthView__Footer', {
        'AuthView__Footer--sm': sm,
      })}
      >
        <TranslationProvider
          translationKey="onboarding.no_account"
        >
          <span>Don’t have an account?&nbsp;</span>
        </TranslationProvider>
        <TranslationProvider
          translationKey="signup"
        >
          <Button
            onClick={handleSignUpClick}
            type="button"
            style={{ textTransform: 'capitalize' }}
            variant="link-inline"
            id="sign-up-button"
            data-dd-action-name={SIGN_UP_DD_ACTION_NAME}
          >
            Sign Up
          </Button>
        </TranslationProvider>
      </div>
    </div>
  );
};

LoginView.propTypes = {
  containerQuery: containerQueryProps,
  email: PropTypes.string,
  event: PropTypes.func,
  onForgotPasswordClick: PropTypes.func.isRequired,
  onSignupClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  venue: PropTypes.string,
};

LoginView.defaultProps = {
  containerQuery: {},
  email: '',
  event: () => {},
  venue: null,
};

LoginView.displayName = 'LoginView';

export default LoginView;
